// extracted by mini-css-extract-plugin
export default {"actions":"ChangePassword_actions__O6H3C","inputContainer":"ChangePassword_inputContainer__QJRW0"};